import {css} from 'styled-components';

/**
 * What every text box in the agent shares: the prompt, an edited message, the feedback answer.
 * Each one adds its own frame and sizing. The shared library has no textarea of its own.
 */
export const agentTextFieldBase = css`
    width: 100%;
    box-sizing: border-box;
    border: none;
    background: transparent;
    font-family: inherit;
    font-size: var(--font-size-body);
    color: var(--color-text-default);
    text-align: start;
    resize: none;

    &::placeholder {
        color: var(--color-text-subtle);
    }

    &:focus {
        outline: none;
    }
`;
